{
  "Business": "Business",
  "Employment": "Employment",
  "Customers": "Customers",
  "Supplier": "Supplier",
  "Suppliers": "Suppliers",
  "Employees": "Employees",
  "Other": "Other",
  "View all categories": "View all categories",
  "Templates": "Templates",
  "AustralianTemplates": "Australia templates",
  "AustralianTemplatesDocx": "Australia templates .docx",
  "UKTemplates": "United Kingdom templates",
  "CompanyTemplates": "Company templates",
  "noSecondPartyCategory": "No second party category",
  "welcomingText": {
    "morning": "Good morning",
    "afternoon": "Good afternoon",
    "evening": "Good evening",
    "night": "Good night",
    "welcome": "Welcome"
  },
  "countries": {
    "uk": "United Kingdom",
    "au": "Australia"
  },
  "searchInputText": {
    "placeholder": "Find your supplier or employment template...",
    "shortPlaceholder": "Search for template..."
  },
  "breadcrumbs": {
    "home": "Home"
  },
  "pages": {
    "home": "Home",
    "templateCategories": "Document library",
    "plan": "Pricing",
    "settings": "Settings",
    "employeeProfiles": "Employee profiles",
    "employeeProfile": "Profile",
    "supplierProfiles": "Supplier profiles",
    "customerProfiles": "Customer profiles",
    "documentVault": "Document vault",
    "signing": "Document signing",
    "createEmployee": "Create employee",
    "createCustomer": "Create customer"
  },
  "select": {
    "defaultValueLabel": "All"
  },
  "buttons": {
    "addPreferredContactMethod": "Add Contact Method",
    "library": "Library",
    "documentLibrary": "Document Library",
    "bookADemo": "Book a Demo",
    "createProfiles": "Add Profile",
    "eSign": "eSign",
    "addTask": "Add Task",
    "employmentTemplatesInfo": "Employment Templates Useful Information",
    "continue": "Continue",
    "deleteChosenPlaceholders": "Delete Chosen Placeholders",
    "documents": "Documents",
    "copyEmailToClickBoard": "Copy Email to Clipboard",
    "buyNow": "Buy Now",
    "employeeDeletionNotAvailable": "Employee Can't Be Deleted",
    "uploadFiles": "Upload Files",
    "uploadAndSignPDF": "Start eSigning",
    "createNote": "Create Note",
    "newDocument": "New Document",
    "signDocuments": "Sign Documents",
    "storeDocuments": "Store Documents",
    "new": "New",
    "pendingSigning": "Pending Signing",
    "submitting": "Submitting...",
    "signedDocument": "Signed Document",
    "documentInSigning": "Document in Signing",
    "assignAndSign": "Assign and Sign",
    "signWithoutAssignee": "Sign without Assignee",
    "book": "Book",
    "card": "Card View",
    "list": "List View",
    "send": "Send",
    "back": "Go Back",
    "viewLatestVersion": "View Latest Version",
    "viewOriginalPDF": "View Original PDF",
    "retry": "Retry",
    "saveContent": "Save",
    "start": "Start",
    "viewContent": "View Content",
    "backToRecent": "Back to Recent",
    "business": "Business",
    "documentTerms": "Document Terms",
    "accept": "Accept",
    "addMoreFiles": "Add More Files",
    "addProfile": "Add Profile",
    "selectFile": "Select a File",
    "selectFiles": "Select Files",
    "accountSettings": "Account Settings",
    "submit": "Submit",
    "store": "Store",
    "businessKitzLibrary": "Business Kitz Library",
    "ownLibrary": "My Templates",
    "templateLibrary": "Template Library",
    "employee": "Employee",
    "supplier": "Supplier",
    "customer": "Customer",
    "ok": "OK",
    "later": "Maybe Later",
    "letsTalk": "Let's Talk",
    "getStarted": "Get Started",
    "invite": "Invite",
    "filter": "Apply Filters",
    "resetFilters": "Reset Filters",
    "sortByDate": "Sort by Date",
    "sortByName": "Sort by Name",
    "sortByFileType": "Sort by File Type",
    "getSummaryWithAI": "Get Summary with AI",
    "goToTemplatePage": "Go to the Template Page",
    "createTemplate": "Create Template",
    "addRow": "Add Row",
    "deleteRow": "Delete Row",
    "logout": "Logout",
    "download": "Download",
    "downloadDocument": "Download",
    "inviteEmployee": "Invite Employee",
    "viewAllCategories": "View All Categories",
    "bookalopeDownload": "Download Bookalope Template",
    "bookalopeGenerate": "Generate Bookalope Template",
    "next": "Next",
    "signUp": "Sign up",
    "forgotPassword": "Forgot Password",
    "signIn": "Sign in",
    "resetPassword": "Reset Password",
    "logIn": "Log in",
    "resetCouponCode": "Reset Coupon Code",
    "applyCouponCode": "Apply Coupon Code",
    "confirm": "Confirm",
    "changePassword": "Change Password",
    "update": "Update",
    "createAccount": "Create Account",
    "addAnEmployee": "Create Employee",
    "editEmployeeProfile": "Edit Profile",
    "yesIam": "Yes I Am",
    "setUpLater": "I Will Set This up Later",
    "edit": "Edit",
    "cancelEditing": "Cancel Editing",
    "stopEditing": "Stop Editing",
    "createCompany": "Create the Business Profile",
    "editButtonTooltipText": "Edit Your Personal Data so It Can Be Used by Your Employer for Your Employment Documents and Workflows.",
    "createSupplier": "Create Supplier",
    "industry": "Industry",
    "addSupplier": "Add Supplier",
    "createContact": "Create Contact",
    "updateContact": "Update Contact",
    "delete": "Delete",
    "deleteContact": "Delete Contact",
    "deleteSupplier": "Delete Supplier",
    "addContact": "Add Contact",
    "editSupplier": "Edit Supplier",
    "saveContact": "Save Contact",
    "updateSupplier": "Update Supplier",
    "goBack": "Go Back",
    "viewMode": "View Mode",
    "openVault": "Open Vault",
    "upload": "Upload",
    "reset": "Reset",
    "uploadToVault": "Upload Document to Vault",
    "collapse": "Collapse",
    "save": "Save",
    "deleteFile": "Delete File",
    "close": "Close",
    "add": "Add",
    "create": "Create",
    "downloadContract": "Download Contract",
    "percents100": "100%",
    "sign": "eSign",
    "addCustomer": "Add Customer",
    "createCustomer": "Create",
    "addContactDetails": "Add",
    "saveContactDetails": "Save",
    "updateContactDetails": "Update",
    "addNotes": "Add",
    "deleteNotes": "Delete",
    "updateNotes": "Update",
    "saveNotes": "Save",
    "analyze": "Analyse",
    "summary": "AI Summary",
    "versions": "Versions",
    "connections": "Connections",
    "viewVersionContent": "View Version Content",
    "copy": "Copy to Clipboard",
    "view": "View",
    "viewTemplate": "View Template",
    "fillTemplate": "Fill Template",
    "deleteTemplate": "Delete Template",
    "createContract": "Create",
    "createDocument": "Create",
    "labels": "Labels",
    "no": "No",
    "change": "Change",
    "cancel": "Cancel",
    "signLatestVersion": "Sign Latest Version",
    "signOriginalDocument": "Sign Original Document",
    "downloadLatestVersion": "Latest Version",
    "editDocumentBeforeDownloading": "You can update the document content or layout in our editor before downloading the latest version.",
    "downloadOriginalDocument": "Original Document",
    "generateContract": "Create Document",
    "copyDocument": "Copy Document",
    "copyTemplate": "Create Template",
    "duplicateTemplate": "Duplicate",
    "duplicateOriginalDocument": "Copy Original",
    "duplicateLatestDocument": "Copy Latest",
    "sendInvitation": "Send Invitation",
    "revoke": "Revoke",
    "revokeInvitation": "Revoke Invitation"
  },
  "categories": {
    "all": "Company templates",
    "viewAllCategories": "View all categories"
  },
  "templatesTable": {
    "nameColumnLabel": "Name",
    "actionColumnLabel": "Action"
  },
  "signUpText": {
    "header": "Sign up to get started with your free account!",
    "subheader": "Sign documents and store important business data.",
    "headerInvitation": "Sign up and join your company’s Business Kitz account."
  },
  "pricingOptionNames": {
    "free": "Free",
    "enterprise": "Enterprise",
    "bestValue": "Best value",
    "businessStarter": "Business starter",
    "businessEssentials": "Business essentials",
    "businessGrowth": "Business growth"
  },
  "pricingOptionsDescription": {
    "free": {
      "priceMonth": "$0 USD/month"
    },
    "businessStarter": {
      "priceMonth": "$25 USD/month",
      "priceYear": "$300 USD/year",
      "description": "12 month access"
    },
    "businessEssentials": {
      "priceEmployee": "$7 USD/Employee",
      "priceMonth": "$140 USD/month",
      "description": "Cancel anytime"
    },
    "businessGrowth": {
      "priceEmployee": "$6 USD/Employee",
      "priceMonth": "$180 USD/month",
      "description": "Cancel anytime"
    },
    "enterprise": {
      "description": {
        "tailoredToYourNeeds": "Tailored to your needs",
        "assessmentFromTopTierLawyers": "Assessment from top-tier lawyers",
        "customIntegration": "Custom integrations",
        "sso": "SSO"
      }
    }
  },
  "applicationFeatures": {
    "employmentLibrary": "Employment library",
    "businessLibrary": "Business library",
    "customerLibrary": "Customer library",
    "manageEmployees": "Manage employees",
    "manageSuppliers": "Manage suppliers",
    "manageCustomers": "Manage customers",
    "createYourOwnDocuments": "Create your own documents",
    "documentSummary": "Document summary",
    "createTemplates": "Create templates",
    "storeDocuments": "Store documents",
    "signDocuments": "Sign documents",
    "libraryLegalReview": "Library legal review",
    "userManagement": "User management",
    "invoiceManagement": "Invoice management",
    "manageTaskWithReminders": "Manage tasks with reminders",
    "autoPilotContractManagement": "Auto-pilot contract management",
    "collaborateAndEdit": "Collaborate and edit"
  },
  "applicationFeaturesDescription": {
    "and": "&",
    "andFrequentlyUpdated": "frequently updated",
    "highQualityTemplates": "High quality templates",
    "documentsDraftedByLawyers": "Documents drafted and updated by lawyers",
    "withAI": "With AI",
    "intelligentDocumentStorage": "Intelligent document storage",
    "toDoList": "To do list"
  },
  "planPageMiscellaneous": {
    "includingGST": "inc. GST",
    "recommended": "Recommended",
    "mostPopular": "Most popular",
    "whatYouWillGet": "What you'll get",
    "features": "Features",
    "comingSoon": "Coming soon",
    "stagedReleasesDuring2025": "Staged releases during 2025",
    "fullAccess": "Full access",
    "gb": "GB",
    "included": "included",
    "unlimited": "Unlimited",
    "documents": "documents",
    "document": "document",
    "month": "month",
    "year": "year",
    "contactMessage": "If you have questions or encounter problems, contact us at ",
    "perMonth": "/month",
    "minPerMonth": "minutes/month",
    "discount": "discount"
  },
  "humanReadablePrice": {
    "free": "$0 USD/month",
    "enterprise": "Users/month"
  },
  "billingInfo": {
    "free": "<ul class='list-unstyled'><li>Download:  5 x templates</li><li>Digitally Sign:  7 x documents p/m</li><li>AI Summary: 5 x documents p/m</li><li>Storage Vault:  2GB documents</li><li>Invite:  5 x employees</li><li>Add Suppliers:  10 x profiles</li><li>Add Customers: 10 x profiles</li></ul>",
    "enterprise": "<ul class='list-unstyled'><li>Tailored to your organizational needs.</li><li>SSO(Single Sign On)</li><li>Custom integrations</li><li>API interface</li></ul>",
    "premium": "<ul class='list-unstyled'><li>Download:  Unlimited templates</li><li>Digitally Sign: 100 x documents p/m</li><li>AI Summary: 100 x documents p/m</li><li>Create templates with AI: 100 x templates p/m</li><li>Storage Vault: 10GB documents</li><li>Invite:  15 x employees</li><li>Add Suppliers: 100 x profiles</li><li>Add Customers: 100 x profiles</li></ul>",
    "billed": "Billed"
  },
  "subscriptionPlanControls": {
    "started": "Started",
    "free": "Started",
    "enterprise": "Contact us",
    "paid": "Get started"
  },
  "settings": {
    "title": "Settings",
    "titleProfile": "Profile settings",
    "signatureDisclosure": "<a href=\"https://signature.businesskits.co.nz/articles/signature-disclosure\" target=\"_blank\">Signature Disclosure</a>",
    "termsAndConditions": "<a href=\"https://www.businesskitz.com/terms-and-conditions\" target=\"_blank\">Terms and Conditions</a>",
    "privacyPolicy": "<a href=\"https://www.businesskitz.com/privacy-policy\" target=\"_blank\">Privacy Policy</a>",
    "signatureDisclosure": "<a href=\"https://signature.businesskitz.com/articles/signature-disclosure\" target=\"_blank\">Signature Disclosure</a>",
    "titles": {
      "plan": "Plan",
      "account": "Account",
      "business": "Company",
      "personal": "Personal",
      "employment": "Employment",
      "emergencyContact": "Emergency contact",
      "qualifications": "Qualifications",
      "documents": "Documents",
      "companyContacts": "Authorised representative",
      "contactsList": "Authorised representatives",
      "notifications": "Notifications"
    }
  },
  "errorMessages": {
    "notFound": "The instance is not found. Please, contact our support if the issue persists.",
    "clientError": "An error occurred. Please, contact our support.",
    "serverError": "An error occurred. Please, try again later.",
    "generalError": "An error occurred. Please, contact our support if the issue persists."
  },
  "messages": {
    "keyDatesDescription": "Track every key date from your documents and subscriptions in one place. Upcoming and overdue dates also appear on your Dashboard.",
    "libraryDescription": "Every essential document and agreement template you need to run your business, regularly updated as laws change and kept in one library.",
    "documentVaultDescription": "Securely upload, sign and manage all your documents in one place, with smarter features coming soon.",
    "employeeProfilesDescription": "Store contracts, payroll, policies and training records for each team member.",
    "supplierProfilesDescription": "Track contracts, invoices, insurance and compliance documents for each supplier.",
    "customerProfilesDesription": "Keep agreements, invoices and correspondence for each customer in one place.",
    "convertToPDFMessage": "eSigning is supported for PDF and generated documents only.",
    "documentCopiedSuccessfully": "Document copied successfully.",
    "templateCopiedSuccessfully": "Template saved to My Templates",
    "signingOriginalDocument": "You will sign the original uploaded document.",
    "signingLatestVersion": "You will sign the latest edited version. Please, keep in mind the formatting will be different from the original uploaded document.",
    "requiredFullName": "Field value is required",
    "unexpectedErrorMessage": "An unexpected error occurred",
    "redirectingToDocumenso": "Documents list is opened in the separate tab.",
    "authError": "Authentication Error",
    "retryAuth": "Retry Authentication",
    "authWait": "Please wait while we complete the authentication process.",
    "authSuccess": "Authentication Successful",
    "authenticating": "Authenticating...",
    "returnToHome": "Return to Home",
    "failedDocumensoRedirect": "Failed to redirect to signing page.",
    "generalErrorMessage": "An error occurred.",
    "contactWording": "Contact",
    "pleaseContact": "Please, contact",
    "toChangePlan": "to change the plan",
    "chooseSaveAsPDF": "Please, choose 'Save as PDF' as the destination option in the next window.",
    "demoBookingDuplication": "You have already submitted a demo booking for this email address",
    "inviteEmployeeMessage": "To invite the employee, please, provide email address or business email address.",
    "choosePlaceholdersFirst": "Please, choose the placeholders you want to delete.",
    "flattenedPDFMessage": "This document is a scanned or print-only PDF and cannot be edited. Such PDF files are treated as images within Business Kitz.",
    "filesProcessedSuccessfully": "All files processed successfully!",
    "contactSuccessfullyCreated": "Contact has been created.",
    "businessNameValidationMessage": "Only letters, numbers, white spaces, '&', and '-' are allowed",
    "invitationSentToEmployee": "An invitation has been sent to the employee",
    "noPermissionsMessage": "Sorry, you don't have permissions for this operation.",
    "documentSentForReview": "Document successfully sent for review.",
    "callBooked": "Call booked successfully.",
    "markedAsSigned": "This document is marked as signed, but it's still possible to sign it with our system",
    "signingSignedStatus": "Click to see the signed document.",
    "signingPendingStatus": "Document is in pending or progress to be signed. Click to see the document.",
    "signingRecommendations": "Assign this document to a person (speed up the signing process and organise documents).",
    "pdfConversionMessagePart1": "To edit this PDF, we'll convert it into an editable document. Some formatting, such as images, tables, fonts, or layouts, may change during the conversion.",
    "pdfConversionMessagePart2": "Your original PDF will remain unchanged and can always be viewed, downloaded, or sent for eSigning.",
    "topTemplatesEmptyMessage": "The most important document templates businesses need, will be added here in a few seconds.",
    "legalKitzPartnerMessage": "Book a consultation with Legal Kitz for guidance on contracts, employment law, business structuring, and IP protection. From startup launch to enterprise growth, our seasoned experts deliver clear, actionable advice.",
    "ctaMessageLegalKitz": "Book your complimentary 30-minute consultation now.",
    "creatingHTMLForPDF": "Preparing your pdf for editing, the editable version might differ a bit in style and formatting after the conversion.",
    "delete": "Delete",
    "customLabelMessage": "The custom list of labels separated with a comma: label 1, label 2, label 3, etc.",
    "selectFileMessage": "Select a file or drag and drop here",
    "selectFilesMessage": "Select or drag and drop up to 5 files",
    "finishCompanySetUp": "To finish up setting up your account, enter your Business details",
    "userNotAssociatedWithCompany": "User is not associated with any company.",
    "considerStartingPlanLibrary": "Please consider starting or upgrading a plan to have full access to the document library. ",
    "exceededPlanLimits": "Exceeded plan limits.",
    "limitCustomers": "You've reached the limit of suppliers per company. Please consider upgrading your plan to add more profiles. ",
    "limitSuppliers": "You've reached the limit of suppliers per company. Please consider upgrading your plan to add more profiles. ",
    "limitEmployees": "You've reached the limit of employees per company. Please consider upgrading your plan to add more profiles. ",
    "considerStartingPlan": "Please consider starting a plan to add more profiles.",
    "paidPlanEmployees": "Start a paid plan to begin managing your employees. ",
    "paidPlanSuppliers": "Start a paid plan to begin managing your suppliers. ",
    "paidPlanCustomers": "Start a paid plan to begin managing your customers. ",
    "monthLimitReached": "You have reached the limit for this month, consider upgrading a plan to gain full access. ",
    "downloadSuccess": "Download successful",
    "employeeCreated": "Employee has been created. ",
    "employeeInvited": "Employee has been invited to join the company on ",
    "contact": {
      "subscriptionTab": "If you have questions about your plan, please, contact us at "
    },
    "documentUpdated": "The document has been updated",
    "companyCreated": "Company has been created.",
    "companyUpdated": "Company details have been updated.",
    "userDataUpdated": "Your data has been updated.",
    "errorOccurred": "An error occurred.",
    "firstAIContractFail": "Contract generation failed, please check your internet connection and try again. if the error persists please contact our support at: support@businesskitz.com.au to get help.",
    "firstAISummaryFail": "AI summary failed, please check your internet connection and try again. if the error persists please contact our support at: support@businesskitz.com.au to get help.",
    "firstAITemplateFail": "Template creation failed, please check your internet connection and try again. if the error persists please contact our support at: support@businesskitz.com.au to get help.",
    "firstDocumentConversionFail": "Document conversion failed, please check your internet connection and try again. if the error persists please contact our support at: support@businesskitz.com.au to get help.",
    "downloadMessageTitle": "Download can start for less than a coffee per day.",
    "startSubscription": "In order to have access to all legal proof templates for your business, please start a subscription",
    "inviteHasBeenSent": "Invite has been sent!",
    "fieldRequired": "This field is required",
    "emailNotValid": "Email is not valid",
    "inviteEmployeeText": "Invite employees to",
    "inviteEmployeeEnterEmailText": "Please enter the email address of your employee(s) and click the envelope button to send your employee(s) an invite. You can add more employees by clicking the “Add more” button located at the bottom left corner of this screen. You can manage your employee count under the Settings tab in the side menu located at the left of the screen.",
    "enterBusinessDetails": "To finish setting up your account, enter your Business details.",
    "maxLength255": "Max length 255",
    "enterCorrectPhoneNumber": "Please, enter a correct phone number",
    "ABNandACNMessage": "ABN must be 11-digit number, ACN must be 9-digit number.",
    "confirmingAccount": "Confirming your account...",
    "resendVerificationIn": "Resend verification code in",
    "resendVerificationCode": "Resend verification code",
    "emailSent": "We have sent you a confirmation email. If you don’t find it in your Inbox, please check your Spam folder.",
    "atLeast12Characters": "Must contain at least 12 characters",
    "uppercaseLowercase": "Must contain at least one uppercase and one lowercase letter",
    "atLeastOneNumber": "Must contain at least one number",
    "atLeastOneSpecialCharacter": "Must contain at least one special character, e.g., ! @ # ?",
    "maximum128Characters": "Ensure this field has no more than 128 characters",
    "getInTouch": "Get in touch with us for a quote:",
    "operationMessage": "Operation message",
    "couponDiscountApplied": "Your coupon discount has been applied. Please, click \"Confirm\" to complete subscription.",
    "promoCodeNotValid": "Sorry, your promo code is not valid or has expired.",
    "fillInRequiredFields": "Please, fill in the required fields (marked with \"*\").",
    "100percentDiscount": "You have got a 100% off discount and do not need to enter your payment details.",
    "acknowledgeAccept": "By clicking \"Confirm\", you acknowledge and accept",
    "termsAndConditions": "Business Kitz Subscription Terms and Conditions",
    "yourNextPayment": "Your next payment of",
    "deducted": "will be deducted on",
    "valueGreaterEqualTo0": "Ensure this value is greater than or equal to 0.",
    "noActiveSubscription": "You do not have active subscriptions. Please, check our available",
    "noMoreThan150Characters": "Ensure this field has no more than 150 characters",
    "noMoreThan255characters": "Ensure this field has no more than 255 characters",
    "readyToFillBusinessInformation": "Are you ready to fill in your business information?",
    "enterTemplateName": "Enter template name here",
    "contactSupport": "If you haven't found the necessary template, please, contact us at ",
    "passwordMismatch": "Password mismatch",
    "businessDetailsEmployee": "Business details below cannot be modified by Employees, the Business or Company profile details are displayed for information use only.",
    "noEmployeesLine1": "Below you will see all your employees and their profiles. Click “Create employee” to add your employee’s profile data to the platform.",
    "noEmployeesLine2": "Employee profiles will store your employees' documents and data, making compliance and record keeping easier. In the future, you will be able to generate documents and send bulk communications to all of your employees.",
    "noDocuments": "No documents associated with this entity have been found.",
    "noSuppliers": "Below you will see all your suppliers and their profiles. Click “Add supplier” to add your supplier’s profile data to the platform.",
    "noSuppliers2": "Click “Add supplier” to start adding your supplier’s profile data to the platform.",
    "noSuppliers3": "Supplier profiles allow you to efficiently manage your suppliers and centralise their documents and data. This streamlines supplier management, ensuring everything is securely stored and easily accessible on the platform.",
    "supplierCreated": "Supplier has been created.",
    "supplierUpdated": "Supplier has been updated.",
    "supplierDeleted": "Suppler has been deleted.",
    "employeeDeleted": "Employee has been deleted.",
    "contactCreated": "Contact item has been created.",
    "preferredContactMethodAdded": "Preferred contact method has been added.",
    "contactDeleted": "Contact item has been deleted.",
    "contactUpdated": "Contact item has been updated.",
    "deleteSupplier": "Delete supplier",
    "deleteEmployee": "Delete employee",
    "deleteContact": "Delete contact",
    "deleteSupplierDialog": "Are you sure you want to delete the supplier profile? This action is permanent.",
    "deleteBusinessContactDialog": "Are you sure you want to delete this contact? This action is permanent.",
    "deleteEmployeeDialog": "Are you sure you want to delete the employee profile? This action is permanent.",
    "deleteContactDialog": "Are you sure you want to delete the supplier contact? This action is permanent.",
    "deleteCompanyContactDialog": "Are you sure you want to delete the company contact? This action is permanent.",
    "deleteDefault": "Are you sure you want to delete the item? This action is permanent.",
    "deleteTodoDialog": "Are you sure you want to delete the task?",
    "dragAndDrop": "Drag and drop files here, or ",
    "clickToUpload": "Click here or drag and drop to upload a file",
    "documentUploaded": "Document uploaded",
    "deleteFile": "Are you sure you want to delete the file? This action is permanent.",
    "deleteDocumentDialog": "Are you sure you want to delete this document? This action is permanent.",
    "storeDocuments": "Store your documents to the workflow it belongs to below. ",
    "companyContactAdded": "Company contact has been added.",
    "addEmployeeAsContact": "Add an authorised representative from your employee list to be used for contract generation and document signing.",
    "addEmployeeFromList": "You can add a contact from the employees list and mark him or her as an authorised representative:",
    "addEmployeeToAuthorize": "Create employee to authorise",
    "contractGeneratorGeneralMessage": "Our AI will use selected data sets to autogenerate employment documents for you, thus saving you time instead of filling manually documents",
    "selectAUser": "Select a user from the list to add their data to the system so it can be used to autogenerate employment documents with our AI",
    "contractGeneratorFinalStep": "Our AI will generate  the document with the selected data and will save it in the browser’s default download folder.",
    "templateGenerated": "The template has been successfully generated.",
    "released": "Available now",
    "downloadingStarted": "Downloading started",
    "supportedFormats": "Supported formats: DOC, DOCX, PDF, PNG, JPEG, HEIC",
    "supportedFormatsImages": "Supported formats: PNG, JPEG, PDF, HEIC",
    "supportedFormatsPDF": "Supported formats: PDF",
    "pleaseContactUsGeneral": "Please, contact us at ",
    "pdfMessage": "Unsupported File Format: Business Kitz currently supports signing documents in DOC, DOCX, and PDF formats only. Please upload a file in one of these formats to proceed. For assistance, contact us at support@businesskitz.com.au",
    "featureComingSoon": "Coming soon.",
    "customerUpdated": "Customer has been updated.",
    "customerCreated": "Customer has been created.",
    "customerDeleted": "Customer has been deleted",
    "deleteCustomerNotesDialog": "Are you sure you want to delete the customer note? This action is permanent.",
    "deleteNoteDialog": "Are you sure you want to delete this note? This action is permanent.",
    "deleteCustomer": "Delete customer",
    "deleteCustomerDialog": "Are you sure you want to delete the customer profile? This action is permanent.",
    "deleteContactDetail": "Delete contact detail",
    "contactDetailDeleted": "Contact details deleted.",
    "contactDetailUpdated": "Contact details updated.",
    "contactDetailCreated": "Contact details created.",
    "deleteContactDetailsDialog": "Are you sure you want to delete the contact details? This action is permanent.",
    "deleteNotes": "Delete notes",
    "deleteNote": "Delete note",
    "deleteEmployeeNote": "Delete employee note",
    "documentVaultComingSoon": "Coming soon:  Create folders, tagging, labels and links to profiles will be some of the Intelligent storage features that we are working on",
    "notesDeleted": "Notes deleted.",
    "notesUpdated": "Notes updated.",
    "notesCreated": "Notes created.",
    "reviewSettings": "Please, review the settings below for better results",
    "AISummaryMessage": "Document analysis and summary",
    "contextualInformationPlaceholder": "Please write down any contextual information that might help in analysing the document for better results",
    "AIFunctionalityMessage": "AI query settings",
    "documentContentSaved": "Document content has been saved!",
    "textCopied": "Text copied.",
    "AITemplateCreatMessage": "Create a template from this document",
    "deletePlaceholdersDialog": "Are you sure you want to delete the chosen template placeholders? This action is permanent.",
    "templatePlaceholderUpdated": "Template placeholder updated.",
    "templatePlaceholderCreated": "Template placeholder created.",
    "deleteTemplatePlaceholder": "Are you sure you want to delete the template placeholder? This action is permanent.",
    "templatePlaceholdersDeleted": "Template placeholders have been deleted.",
    "templateCreated": "Template has been created.",
    "viewTemplateMessage": "Newly created templates are saved in Document Vault under Templates folder.",
    "templateUpdated": "Template has been updated",
    "aiSummaryMessage": "Upload any document to the Document Vault and click on the ‘Document Analysis and Summary’ icon to instantly generate a detailed summary of your document within seconds.",
    "contractCreated": "Document has been created",
    "templatesFromVault": "Create editable document templates from any document in the Vault.",
    "templateFromVaultEmpty": "Upload any document to the vault and start creating a template.",
    "templateFromVaultWithDocs": "Select any document from the vault and start creating a template.",
    "deleteTemplate": "Are you sure you want to delete the template? This action is permanent.",
    "contractGenerated": "Document has been generated.",
    "signupNotAvailable": "Sorry, the signup is not available now.",
    "fileTypeToDownload": "Please, choose the file type for downloading and enter the new file name if necessary.",
    "loading": "Loading...",
    "signingVersionMessage": "Do you want to sign the latest version or the original document?",
    "downloadingVersionMessage": "Do you want to download the latest version or the original document?",
    "emptyDocumentsMessage": "Your documents will be listed here after you upload one",
    "emptyCustomersMessage": "No customers found",
    "emptySuppliersMessage": "No suppliers found",
    "duplicatingVersionMessage": "Choose which version of the document to copy",
    "documentDuplicated": "Document copied successfully.",
    "contactAdministrator": "You do not have permission for the action. Contact your company administrator.",
    "whichEmailToUse": "Which email to use?",
    "invitationWillBeSentTo": "Invitation will be sent to ",
    "invitationRevokeMessage": "Are you sure you want to revoke the invitation to join organisation ",
    "invitationSentTo": "Invitation has been sent to ",
    "couldNotBeSent": "could not be sent",
    "invitationTo": "Invitation to",
    "todoLinkTip": "To add a link, write: [link text](https://example.com)",
    "phoneInvalid": "Enter a valid phone number",
    "phoneNotWhatsApp": "WhatsApp can't reach landlines, enter a mobile number",
    "whatsappNeedsMobile": "To get WhatsApp updates, add a mobile number in your"
  },
  "links": {
    "here": "here",
    "pricingOptions": "pricing options",
    "termsAndConditions": "Terms and Conditions",
    "softwareTermsOfUse": "Software Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "businessProfile": "Business Profile"
  },
  "inputs": {
    "employeeEmailTitle": "Employee email"
  },
  "labels": {
    "pageOfTotal": "Page {{page}} of {{total}}",
    "documentCategories": "Document categories",
    "documentActions": "Document actions",
    "watchVideo": "Watch video",
    "documentTabs": "Document tabs",
    "noSupplier": "No supplier",
    "noCustomer": "No customer",
    "generalUnassigned": "Unassigned",
    "generalAdministration": "General administration",
    "dateCreated": "Date created",
    "action": "Action",
    "menuButton": "Menu button",
    "region": "Region",
    "fines": "Fines",
    "resolutionCost": "Resolution cost",
    "processing": "Processing",
    "file": "file",
    "documentsView": "Documents view",
    "searchByName": "Search by name",
    "howLibraryWorks": "How the Document Library works",
    "libraryView": "Library view",
    "customerProfilesView": "Customer profiles view",
    "supplierProfilesView": "Supplier profiles view",
    "address": "Address",
    "templateDefault": "Template",
    "templateName": "Template name",
    "selectSupplier": "Supplier name",
    "remaining": "remaining",
    "pending": "Pending Signing",
    "upcoming": "Upcoming",
    "overdue": "Overdue",
    "dontShowThisMessageAgain": "Do not show this message again.",
    "templates": "templates",
    "copy": "Copy",
    "aud": "AUD",
    "eur": "EUR",
    "gbp": "GBP",
    "usd": "USD",
    "currency": "Currency",
    "hourly": "Hourly",
    "weekly": "Weekly",
    "biweekly": "Biweekly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "yes": "Yes",
    "no": "No",
    "customLabel": "Custom label(s)",
    "subscription": "Subscription",
    "frequency": "Frequency",
    "signed": "Signed",
    "amount": "Amount",
    "workflow": "Workflow",
    "assignTo": "Assign to",
    "assigned": "Assigned",
    "choose": "Choose",
    "chooseAssignee": "Choose assignee",
    "chooseWorkflow": "Choose workflow",
    "chooseDocumentType": "Choose document type",
    "employee": "Employee",
    "supplier": "Supplier",
    "customer": "Customer",
    "businessName": "Business name",
    "businessNumber": "Business number",
    "businessRegistrationNumber": "Business registration number",
    "createDocument": "Create document",
    "new": "New",
    "more": "More",
    "free": "Free",
    "all": "All",
    "actions": "Actions",
    "showAll": "Show all",
    "bkGeneratedDocument": "Business Kitz created document",
    "labels": "Labels",
    "useLatestVersion": "Use latest version",
    "documentWorkflow": "Document workflow",
    "profileName": "Profile Name",
    "date": "Date",
    "documents": "Documents",
    "chooseSecondPartyCategory": "Choose second party category",
    "chooseProfile": "Choose profile",
    "chooseSecondParty": "Profile name",
    "phone": "Phone",
    "socialMedia": "Social media",
    "detailType": "Type",
    "detail": "Contact",
    "contactName": "Contact name",
    "customerDocuments": "Customer documents",
    "customerDetails": "Details",
    "supplierDocuments": "Supplier documents",
    "customerName": "Customer name",
    "contactNumber": "Phone number",
    "bookACall": "Book a consultation",
    "sendDocumentForReview": "Send for Legal Review",
    "websiteOrSocial": "Website or social networks",
    "industryType": "Industry type",
    "preferences": "Preferences",
    "preferredContactMethod": "Preferred contact method",
    "preferredCurrency": "Preferred currency",
    "businessOrCompany": "Business name",
    "description": "Description",
    "businessPhoneNumber": "Business phone number",
    "ABNorACN": "Business registration number",
    "registrationNumberTypes": "AU: ABN/ACN; UK: CRN; USA: EIN/TIN; EU: EUID/VAT",
    "numberOfWorkers": "Company members",
    "emailAddress": "Email address",
    "password": "Password",
    "yourAccountEmailAddress": "Your account email address",
    "repeatPassword": "Repeat password",
    "for": "For",
    "plan": "Plan",
    "billing": "Billing",
    "users": "Users",
    "dueIn": "Due in",
    "days": "days",
    "dueToday": "Due today",
    "cardNumber": "Card number",
    "expiryDate": "Expiry date",
    "cvv": "CVV",
    "cardHolderName": "Cardholder name",
    "addressLine1": "Address line 1",
    "addressLine2": "Address line 2",
    "country": "Country",
    "stateProvince": "State/Province",
    "city": "City",
    "zipPostal": "Zip/postal",
    "yourCoupon": "Your coupon code (if any)",
    "enterYourCouponCode": "Enter your coupon code",
    "startDate": "Start date",
    "endDate": "End date",
    "endRenewalDate": "Date end / renewal",
    "currentPeriodStart": "Current period start",
    "currentPeriodEnd": "Current period end",
    "nextPayment": "Next payment",
    "termsOfSubscription": "Term of subscription (in months)",
    "status": "Status",
    "firstName": "First name",
    "fullName": "Full name",
    "lastName": "Last name",
    "email": "Email",
    "postalAddress": "Postal address",
    "employmentDetails": "Employment details",
    "jobTitle": "Job title",
    "basicOfWork": "Basic of work",
    "positionDescription": "Position description",
    "employmentType": "Employment type",
    "paymentDetails": "Payment details",
    "accountDetails": "Account details",
    "accountNumber": "Account number",
    "bsb": "BSB",
    "accept": "I accept the ",
    "agreeWith": "I agree with the ",
    "cityCounty": "City/county",
    "phoneNumber": "Phone number",
    "postalCode": "Postal code",
    "positionTitle": "Position title",
    "positionType": "Position type",
    "department": "Department",
    "positionStartDate": "Start date",
    "positionEndDate": "End date",
    "relationship": "Relationship",
    "degreeOrCertificate": "Degree or certificate name",
    "institutionName": "Institution name",
    "middleName": "Middle name",
    "employeeId": "Employee identification number",
    "employeeTaxNumber": "Employee tax number",
    "businessEmailAddress": "Business email address",
    "gender": "Gender",
    "supplierName": "Supplier name",
    "supplierEmail": "Supplier email",
    "supplierRegistrationNumber": "Supplier registration or tax number",
    "customerRegistrationNumber": "Customer registration or tax number",
    "physicalAddress": "Physical address",
    "website": "Website",
    "type": "Type",
    "industry": "Industry",
    "supplierDescription": "Supplier description",
    "supplierIndustry": "Supplier industry",
    "authorizedRepresentative": "Authorised representative",
    "uploadedFile": "Uploaded file: ",
    "chooseEmployee": "Choose employee",
    "companyData": "Company data",
    "businessDetails": "Business details",
    "employeeData": "Employee data",
    "selectOutputFormat": "Select output format",
    "saveDocumentToVault": "Save document to vault",
    "subtotal": "Subtotal",
    "gstStandAlone": "GST",
    "gst": "GST 10%",
    "documentType": "Document type",
    "category": "Category",
    "purpose": "Purpose",
    "resultFormat": "Result format",
    "detailLevel": "Detail level",
    "simplifyJargon": "Simplify technical or legal jargon",
    "contextualInformation": "Contextual information",
    "fileName": "File name",
    "fileType": "File type",
    "uploadDate": "Upload date",
    "profile": "Profile",
    "connected": "Connected",
    "changeDate": "Change date",
    "version": "Version",
    "field": "Field",
    "placeholder": "Placeholder",
    "value": "Value",
    "name": "Name",
    "company": "Company",
    "pendingSince": "Pending since",
    "memberSince": "Member since",
    "noAssignee": "No assignee"
  },
  "slideTitles": {
    "documentVault": "Document vault",
    "documentLibrary": "Document library",
    "digitalSigning": "Document signing",
    "profiles": "Employee, customer & supplier profiles",
    "ai": "Integrated AI to supercharge your business productivity"
  },
  "slidesDescription": {
    "documentStorage": "Document storage and workflows, made simple.",
    "premiumDocs": "Access hundreds of premium business agreements, policies and templates.",
    "seamlesslySign": "Digitally sign all your business documents and store them on our secure platform.",
    "aiBrief": "Create a ready-to-sign documents and templates. "
  },
  "loginText": {
    "header": "Welcome back!"
  },
  "brandContent": {
    "header": "Features coming soon"
  },
  "passwordReset": {
    "header": "Enter your new password.",
    "header2": "Reset password message",
    "message": "We have sent you a reset password email. If you don’t find it in your Inbox, please check your Spam folder."
  },
  "contactUs": {
    "header": "Contact us",
    "message": "If you have questions or encounter problems, contact us at:"
  },
  "planConfirmation": {
    "header": "Confirm your plan.",
    "paymentDetailsHeader": "Payment details",
    "yourPlan": "Your plan",
    "perUserItem": "per user/"
  },
  "passwordRules": {
    "atLeast12characters": "At least 12 characters.",
    "uppercaseLowercase": "A mixture of both uppercase and lowercase letters.",
    "atLeastOneNumber": "Inclusion of at least one number.",
    "atLeastOneSpecialCharacter": "Inclusion of at least one special character, e.g., ! @ # ? ]",
    "passwordsMustMatch": "Passwords must match."
  },
  "employees": {
    "header": "Employees"
  },
  "businessDetails": {
    "header": "Business details"
  },
  "employeeProfiles": {
    "header": "Employee Profiles"
  },
  "positionTypes": {
    "casual": "Casual",
    "contract": "Contract",
    "intern": "Intern"
  },
  "relationship": {
    "parent": "Parent",
    "partner": "Partner",
    "friend": "Friend",
    "guardian": "Guardian",
    "sibling": "Sibling"
  },
  "supplierPage": {
    "createSupplierHeader": "Create a supplier"
  },
  "supplierProfiles": {
    "header": "Supplier profiles",
    "supplierContactsList": "Supplier contacts list"
  },
  "customerProfiles": {
    "header": "Customer profiles",
    "noItemsSubheader1": "Below you will see all your customers and their profiles. Click “Add customer” to start adding your customer's profile data to the platform.",
    "noItemsSubheader2": "Customer profiles will store your customer's documents and data, making managing your customers easier. In the future, you will be able to quickly generate documents and send communications to your customers."
  },
  "industryTypes": {
    "businessPartner": "Business partner",
    "contractor": "Contractor",
    "supplierOfGoodsAndServices": "Supplier of goods and services",
    "consultant": "Consultant",
    "manufacturer": "Manufacturer",
    "client": "Client"
  },
  "dialogTitles": {
    "deleteTemplate": "Delete template",
    "createTemplate": "Create",
    "deleteSupplier": "Delete supplier",
    "deleteContact": "Delete contact",
    "deleteDefault": "Delete",
    "deleteFile": "Delete file",
    "deleteDocument": "Delete document",
    "deleteNotes": "Delete notes",
    "deleteCustomer": "Delete customer",
    "deleteEmployee": "Delete employee",
    "deleteContactDetails": "Delete contact details",
    "editDocument": "Edit document",
    "aiSummary": "AI summary",
    "deletePlaceholders": "Delete template placeholders",
    "getSummaryWithAI": "Get summary with AI",
    "chooseFileType": "Choose file type to download",
    "chooseEmail": "Select email to invite",
    "chooseEmail2": "as an employee to join Business Kitz."
  },
  "supplierTabs": {
    "basicDetails": "Company",
    "documents": "Documents",
    "contacts": "Contacts"
  },
  "customerTabs": {
    "basicDetails": "Customer",
    "contactDetails": "Contact details",
    "notes": "Customer notes",
    "documents": "Documents",
    "customerDetails": "Customer"
  },
  "contractGeneratorDialog": {
    "generatorTitle": "Create a new document",
    "formatPDF": "PDF",
    "formatWord": "Word",
    "noEmployee": "No employee",
    "noSecondParty": "None"
  },
  "customerPage": {
    "createCustomerHeader": "Create a customer"
  },
  "documentTypes": {
    "agreement": "Agreement",
    "contract": "Contract",
    "invoice": "Invoice",
    "insurance": "Insurance",
    "certificate": "Certificate or license",
    "subscription": "Subscription",
    "other": "Other",
    "statementOrReport": "Statement or report"
  },
  "purpose": {
    "verification": "Verification",
    "analysis": "Analysis",
    "recordKeeping": "Record keeping"
  },
  "resultFormat": {
    "table": "Table",
    "bulletPoint": "Bullet point",
    "narrativeFormat": "Narrative format"
  },
  "detailLevel": {
    "highLevel": "High level (fast)",
    "detailed": "Detailed"
  },
  "documentTabs": {
    "content": "Content",
    "summary": "Summary",
    "versions": "Versions",
    "connections": "Connections",
    "template": "Template",
    "labels": "Labels"
  },
  "documentPage": {
    "headerDefault": "Document"
  },
  "templatePage": {
    "headerDefault": "Template"
  },
  "documentVault": {
    "allDocuments": "All documents",
    "categoryDocuments": "{{category}} documents",
    "howKeyDatesWork": "How Key Dates work",
    "howVaultWorks": "How the Document Vault works",
    "vaultView": "Document Vault view",
    "suppliers": "Suppliers",
    "company": "Company",
    "templates": "Templates",
    "business": "Business",
    "descriptions": {
      "business": "Securely store your company records, registrations, policies and other key business documents.",
      "employment": "Keep every employee’s contracts, records and signed documents securely stored and easy to find.",
      "customers": "Securely store your customer agreements, signed contracts and supporting records.",
      "suppliers": "Keep your supplier and contractor agreements, invoices and records securely stored and organised."
    }
  },
  "categoryCards": {
    "documentCountSingular": "{{count}} document",
    "documentCountPlural": "{{count}} documents",
    "templateCountSingular": "{{count}} template",
    "templateCountPlural": "{{count}} templates",
    "descriptions": {
      "business": "Essential documents and agreement templates to set up, structure and run your business.",
      "employment": "Every essential document and agreement template you need to manage your employees, from recruitment to termination.",
      "customers": "Every essential document and agreement template you need to work with your customers.",
      "suppliers": "Every essential document and agreement template you need to work with your suppliers, including contractors."
    }
  },
  "pageNotFoundHeader": "Page not found",
  "pageNotFoundMessage": "Sorry, the page you are looking for was not found.",
  "goHomeLink": "Go to the home page",
  "companyTemplatesHeader": "Company templates",
  "disclaimerText": {
    "beforeProceeding": "Before proceeding, please review and agree to the terms outlined in the document below. Your acceptance ensures compliance with the specified conditions.",
    "description": "\n\n Business Kitz offers a comprehensive and helpful library of documents on its platform including templates, contracts, forms, letters, policies and other resources made available to you on the platform (“Documents”). If you access, edit or use or download a Document, you agree to be bound by these Document Terms, Business Kitz SaaS ",
    "tosDocAccess": "These Document Terms will apply to your access and use of each and every Document on the Business Kitz platform. If you do not agree to the terms below, please do not use any of the Documents.\n\n",
    "resourceOffering": "Business Kitz provides a platform on which you may have access to resources, document templates, guidance and information to allow you to use, modify, utilise and make decisions about certain subject matter. Business Kitz is not responsible for and has no liability to you in respect of your use, implementation or adaption of any of the Documents or any outcomes arising from your use of the Documents.\n\n",
    "documentAccessibility": "You may access documents provided by Business Kitz on the platform in the ‘Document Library’. We provide these documents to you in connection with your account with us. \n\n ",
    "docAccuracy": "We have made reasonable efforts to review and update the Documents in accordance with market practice, laws and legislative changes, Business Kitz does not warrant the accuracy of Documents or the information or references therein. \n\n",
    "disclaimers": "Business Kitz is not responsible for and disclaims all and any guarantees, undertakings and warranties, expressed or implied, and is not liable for any loss or damage whatsoever arising out of, or in respect of your use, implementation and perceived suitability of the resources on the platform, including the Documents. \n\n",
    "legalities": "Business Kitz is not a law firm and does not provide any legal advice. \n\n",
    "redistribution": "This document template is owned by Business Kitz and is made available to you for your use in accordance with your account on the platform. You must not share, copy, attempt to replicate or publish this document template in any circumstance other than in the ordinary course of your business. You may not share the Documents or sell the Document to any third party.\n\n",
    "intellectualProperty": "All copyright and intellectual property in the Documents is and remains the sole exclusive property of Business Kitz.\n\n",
    "contactInfo": "If you have any questions or queries a Document or these Document Terms, you may contact our team by emailing us at support@businesskitz.com.au or support@businesskitz.com "
  },
  "tagsLabels": {
    "documentType": {
      "agreementOrContract": "Agreement or contract",
      "invoice": "Invoice",
      "certificate": "Certificate or license",
      "insurance": "Insurance",
      "form": "Form",
      "policiesAndProcedures": "Policy or procedure",
      "letter": "Letter",
      "subscription": "Subscription",
      "statementOrReport": "Statement or report"
    },
    "documentWorkflow": {
      "employment": {
        "recruitment": "Recruitment",
        "agreement": "Agreement",
        "newEmployeeManual": "Employee forms and manuals",
        "policiesAndProcedures": "Policies and procedures",
        "induction": "Induction",
        "employeeManagement": "Employee management",
        "probation": "Probation",
        "performanceManagement": "Performance",
        "managingUnderperformance": "Underperformance",
        "accounting": "Payroll",
        "termination": "Termination",
        "generalAdministration": "General administration",
        "idCardsPassportsAndLicenses": "ID cards, passports and licences"
      },
      "supplier": {
        "proposalOrQuote": "Proposal or quote",
        "agreement": "Agreement",
        "invoicing": "Invoices",
        "receipts": "Receipts",
        "projectMaterials": "Project materials",
        "accounting": "Accounting",
        "termination": "Termination",
        "generalAdministration": "General administration"
      },
      "customer": {
        "proposalOrQuote": "Proposal or quote",
        "agreement": "Agreement",
        "invoicing": "Invoices",
        "receipts": "Receipts",
        "customerProjectMaterials": "Project materials",
        "accounting": "Accounting",
        "termination": "Termination",
        "generalAdministration": "General administration"
      },
      "company": {
        "registration": "Business registration and ownership",
        "management": "Management",
        "accounting": "Accounting",
        "subscriptions": "Subscription",
        "agreements": "Agreement",
        "generalAdministration": "General administration",
        "insuranceAndLicenses": "Insurance and licences",
        "assets": "Assets"
      }
    },
    "categories": {
      "employment": "Employment",
      "business": "Business",
      "customers": "Customers",
      "suppliers": "Suppliers"
    }
  },
  "headers": {
    "copyToMyTemplates": "Save a copy to My Templates",
    "employmentTemplatesUsefulInformation": "Employment Templates Useful Information",
    "signingPageHeader": "Signing documents",
    "createCustomerContact": "Create customer contact",
    "administration": "Administration",
    "standardOnboardingPackage": "Standard onboarding package",
    "ultimatePowerHousePackage": "The ultimate powerhouse package",
    "startSigning": "Start signing",
    "signed": "Signed",
    "keyDates": "Key Dates",
    "general": "General",
    "topDocumentTemplates": "Top templates",
    "legalKitz": "Legal Kitz",
    "library": "Document Library",
    "documentTemplates": "Document Library",
    "workflows": "Workflows",
    "employeeProfile": "Employee profile",
    "supplierProfile": "Supplier profile",
    "customerProfile": "Customer profile",
    "settings": "Settings",
    "recent": "Recent",
    "toDo": "To do",
    "documents": "Manage documents",
    "profiles": "Manage profiles",
    "documentVault": "Document Vault",
    "documentLibrary": "Document library",
    "templates": "Templates",
    "documentTerms": "Document terms",
    "documentWorkspace": "Document workspace",
    "businessProfile": "Business profile",
    "properties": "Properties",
    "extras": "Extras",
    "versions": "Versions",
    "aiSummary": "AI document summary",
    "workspace": "Workspace",
    "recentDocuments": "Recent documents",
    "invitation": "Invitation",
    "selectEmail": "Select email"
  },
  "menu": {
    "keyDates": "Key Dates",
    "home": "Home",
    "documents": "Documents",
    "library": "Library",
    "workspace": "Workspace",
    "vault": "Vault",
    "sign": "eSign",
    "profiles": "Profiles",
    "business": "Business",
    "employees": "Employees",
    "customers": "Customers",
    "suppliers": "Suppliers",
    "plans": "Plans",
    "settings": "Settings",
    "logout": "Logout"
  },
  "featureItems": {
    "docLibraryTitle": "Document Library",
    "docLibraryDescription": "Access hundreds of premium business agreements, policies and templates.",
    "docSignTitle": "Document Sign",
    "docSignDescription": "Digitally sign all your business documents and store them on our secure platform.",
    "docVaultTitle": "Document Vault ",
    "docVaultDescription": "Document storage and workflows, made simple.",
    "crmTitle": "CRM made simple",
    "crmDescription": "Manage efficiently your business, employees, customers, suppliers ",
    "integratedAiTitle": "Integrated AI",
    "integratedAiDescription": "Get summary for any documents in seconds.\nCreate a ready-to-sign documents and templates."
  },
  "footerLinks": {
    "support": "Support",
    "privacyPolicy": "Privacy policy",
    "termsAndConditions": "Terms and conditions",
    "businessKitz": "Business Kitz 2026 ©"
  },
  "emptyStateMessages": {
    "profiles": "Your recent profiles will show up here after you create one",
    "documents": "Your recent documents or templates will show up here after you create one",
    "todos": "Your “To do” tasks will be listed here after you create one",
    "emptyLibraryMessage": "Your library templates will be listed here after you upload or create one",
    "aiSummary": "Document insights at a glance",
    "keyDatesDocuments": "Important ending or renewal dates for any document you upload will appear here. Stay informed when a renewal or contract will end."
  },
  "blankDocumentModal": {
    "title": "Create new document",
    "description": "Please provide a name for the document.",
    "documentNameLabel": "Document name",
    "documentNamePlaceholder": "New document name",
    "defaultDocumentTitle": "New document title (heading 1)",
    "defaultDocumentParagraph": "New document paragraph (normal text)"
  },
  "homePageTasks": {
    "uploadAndStoreDocument": "Upload and store a document",
    "createNewDocument": "Create new document",
    "addEmployee": "Add employee",
    "createTemplateFromAIComponents": "Create a template from existing AI components",
    "addSupplierOrCustomer": "Add a supplier or customer",
    "documentSummaryWithAI": "Document summary with AI",
    "startSubscription": "Start subscription"
  },
  "menuItems": {
    "selectAnOption": "Select an option",
    "createNewBlankDocument": "Create new document",
    "createFromBusinessKitzLibrary": "Create from Business Kitz Library",
    "createFromOwnLibrary": "Create from Own Library",
    "createEmployee": "Create an employee",
    "createSupplier": "Create a supplier",
    "createCustomer": "Create a customer"
  },
  "formInputs": {
    "businessNameInputLabel": "Business Name",
    "registrationNumberInputLabel": "Registration Number",
    "taxregistrationNumberInputLabel": "Tax ID or Registration number 2",
    "businessPhoneNumberInputLabel": "Business phone number",
    "postalAddressInputLabel": "Postal Address",
    "businessEmailAddressInputLabel": "Business email address",
    "registeredAddressInputLabel": "Registered Address",
    "physicalAddressInputLabel": "Physical Address",
    "countryInputLabel": "Country",
    "addressInputLabel": "Address",
    "hiringManagerInputLabel": "Hiring Manager",
    "emailAddressInputLabel": "Email Address",
    "authorizedSignInputLabel": "Authorised signatory",
    "positionInputLabel": "Position",
    "legalRepresentationInputLabel": "Legal Representative",
    "phoneInputLabel": "Phone",
    "directorInputLabel": "Director",
    "secretaryInputLabel": "Secretary",
    "accountantInputLabel": "Accountant",
    "accountNameInputLabel": "Account name or holder",
    "accountNumberInputLabel": "Account number or IBAN",
    "swiftInputLabel": "BSB or SWIFT or BIC",
    "bankCountryInputLabel": "Bank country",
    "shareholderInputLabel": "Shareholder",
    "contactNameInputLabel": "Contact name",
    "currencyInputLabel": "Select a currency",
    "noteInputLabel": "Add a note",
    "websiteInputLabel": "Website",
    "physicalCityInputLabel": "Physical City",
    "physicalCodeInputLabel": "Physical Code",
    "physicalCountryInputLabel": "Physical Country",
    "postalCodeInputLabel": "Postal Code",
    "postalCityInputLabel": "Postal City",
    "postalCountryInputLabel": "Postal Country",
    "industryTypeInputLabel": "Industry Type",
    "preferredCurrencyInputLabel": "Preferred Currency",
    "preferredContactMethodInputLabel": "Preferred Contact Method",
    "customerNameInputLabel": "Customer Name",
    "whatsappOptInLabel": "Send me WhatsApp updates about account and document deadlines."
  },
  "businessProfile": {
    "allTab": "All",
    "detailsTab": "Details",
    "contactsTab": "Contacts",
    "documentsTabs": "Documents",
    "notesTab": "Notes",
    "detailsCardHeader": "Details",
    "organizationCardHeader": "Organisation",
    "businessOrganizationCardHeader": "Business / Organisation",
    "documentCardHeader": "Documents",
    "bankCardHeader": "Bank Details",
    "notesTabHeader": "Add a note",
    "addSocials": "Add socials",
    "addContacts": "Add contact",
    "createContact": "Create contact",
    "createNote": "Create note",
    "director": "Director",
    "noDirector": "No Director",
    "accountant": "Accountant",
    "noAccountant": " No Accountant",
    "secretary": "Secretary",
    "noSecretary": "No Secretary"
  },
  "documentsTable": {
    "updated": "Updated",
    "endsRenews": "Ends / renews",
    "starts": "Starts",
    "name": "Name",
    "workflow": "Workflow",
    "fileType": "File type",
    "documentType": "Document type",
    "signed": "Signed",
    "actions": "Actions",
    "date": "Date created / updated",
    "profile": "Profile",
    "fileName": "File name",
    "recentDate": "Recent date"
  },
  "libraryTable": {
    "name": "Template name",
    "requirement": "Requirement",
    "profiles": "Profiles",
    "workflow": "Workflow",
    "documentType": "Document type",
    "dateCreatedModified": "Date created/modified",
    "updatedDate": "Updated {{date}}",
    "actions": "Actions",
    "filterByRequirement": "Filter by Requirement",
    "filter": "Filter",
    "close": "Close",
    "reset": "Reset"
  },
  "employeeDocRequirements": {
    "all": "Every employee",
    "casual": "Casual employees",
    "fixedTerm": "Fixed-term employees",
    "partTime": "Part-time employees",
    "fullTime": "Full-time employees",
    "recommended": "Recommended",
    "helpGuide": "Help guide",
    "asRequired": "As required"
  },
  "confirmModal": {
    "textAlert": "You have unsaved changes. Are you sure you want to leave?",
    "discard": "Discard",
    "save": "Save",
    "tooltip": "I want to discard all changes"
  },
  "addSocialsModal": {
    "tittle": "Edit socials"
  },
  "legalKitz": {
    "legalDocument": "Legal documents review via Legal Kitz",
    "callLegalKitz": "Call with a Legal Kitz contract specialist",
    "discount": "Discount on Legal Kitz services",
    "promoHeadline": "Legal guidance that moves your business forward",
    "promoSubtext": "Contracts, employment, IP and more.\nFree 30-minute consultation.",
    "promoServiceContracts": "Contracts",
    "promoServiceEmployment": "Employment",
    "promoServiceIP": "IP Protection",
    "promoServiceStructuring": "Structuring",
    "promoCtaButton": "Book a Free Consultation"
  },
  "bizCover": {
    "sectionTitle": "Insurance",
    "cardHeadline": "Check your business insurance",
    "optionsHeadline": "Check your business insurance options now",
    "wideBody": "Understand the insurance typically held in your industry, including public liability, professional indemnity and cyber liability, then compare quotes and get your insurance sorted today.",
    "dashboardBody": "Understand the insurance typically held by businesses in your industry, compare quotes and get covered today.",
    "coverTypesLabel": "Common types of business insurance",
    "coverPublicLiability": "Public liability",
    "coverProfessionalIndemnity": "Professional indemnity",
    "coverCyberLiability": "Cyber liability",
    "coverManagementLiability": "Management liability",
    "body": "Understand the insurance typically held by businesses in your industry, compare quotes and get covered today.",
    "ctaButton": "Check your business insurance now",
    "optionsCtaButton": "Check your business insurance now",
    "opensInNewTab": "opens in a new tab",
    "disclosure": "We’ve partnered with BizCover to help you find the right insurance. Insurance is provided by BizCover and its insurers. Business Kitz may receive a commission, at no extra cost to you.",
    "partnerDisclosure": "Business Kitz has partnered with BizCover to help businesses get the cover they need. BizCover compares quotes from a range of insurers, and insurance is provided by BizCover and its insurers, not Business Kitz. Once you have your policy, save a copy in the Insurance and licences section of your <strong>Business Profile</strong> and we'll remind you when it's due for renewal. Business Kitz may receive a commission for referrals, which does not affect the price you pay."
  },
  "regions": {
    "au": "Australia",
    "uk": "United Kingdom",
    "global": "Global"
  },
  "tabs": {
    "all": "All",
    "documents": "Documents",
    "templates": "Templates",
    "documentDetails": "Document details",
    "documentContent": "Document content"
  },
  "miscellaneousText": {
    "version": "Version",
    "for": "for"
  },
  "fileTypes": {
    "template": "Template",
    "pdf": "Portable Document Format",
    "businessKitz": "Business Kitz Editable Document",
    "msWord": "Microsoft Word Format",
    "image": "Image format"
  },
  "pricing": {
    "header": "Pricing Plans",
    "couponButton": "Association Members",
    "subheader": "The smartest teams are already using Business Kitz. Are you?",
    "description": "Business Kitz replaces your back office with one seamless, automated system. 115+ legal templates, AI-powered workflows, secure cloud storage, and effortless eSigning included. The real cost? Staying stuck in the old way."
  },
  "pricingBilling": {
    "monthly": "Monthly",
    "annual": "Annual Save 15%"
  },
  "pricingPlans": {
    "free": {
      "name": "Free",
      "tagline": "A simple way to start organising your documents.",
      "price": "A$0",
      "period": "/ Month",
      "cta": "Start for Free",
      "ctaSubtext": "No credit card required.",
      "features": [
        "<strong>5 eSignatures per month</strong>",
        "<strong>Audit trail for every document</strong> (a secure record of who signed and when)",
        "<strong>Secure document storage</strong>",
        "<strong>10 free high-quality Australian business templates</strong>",
        "<strong>Up to 3 Employee Profiles with simple workflows</strong> (every employee record and contract, securely stored in one place)",
        "<strong>Up to 5 Supplier Profiles with simple workflows</strong> (every supplier and contractor agreement and renewal date, securely stored in one place)",
        "<strong>Up to 5 Customer Profiles with simple workflows</strong> (every customer record and contract, securely stored in one place)",
        "<strong>1 GB data storage</strong>"
      ],
      "unavailable": ["Legal Document Review", "Legal Consult", "Full Template Library"]
    },
    "essentials": {
      "name": "Essentials",
      "tagline": "The essential subscription every Australian business needs to be compliant.",
      "price": "A$69",
      "priceAnnual": "A$703",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Choose Plan",
      "ctaSubtext": "12 month contract",
      "badge": "Most Popular",
      "features": [
        "<strong>100 eSignatures per month</strong>",
        "<strong>Audit trail for every document</strong> (a secure record of who signed and when)",
        "<strong>Secure document storage</strong>",
        "<strong>SmartVault</strong> (intelligent storage coming soon)",
        "<strong>Every Fair Work compliant employment template you need</strong> (hire and manage staff with confidence)",
        "<strong>Full access to the Document Library</strong> (115+ contracts, policies and agreements by trusted Australian lawyers)",
        "<strong>Up to 15 Employee Profiles with simple workflows</strong> (every employee record and contract, securely stored in one place)",
        "<strong>Up to 40 Supplier Profiles with simple workflows</strong> (every supplier and contractor agreement and renewal date, securely stored in one place)",
        "<strong>Up to 40 Customer Profiles with simple workflows</strong> (every customer record and contract, securely stored in one place)",
        "<strong>Unlimited Key Date extractions</strong> (renewals, expiries and annual deadlines such as insurance and licences, tracked in your Key Dates Dashboard)",
        "<strong>1 Legal Document Review by Legal Kitz per month</strong> (a lawyer checks your contract before you sign)",
        "<strong>2 x 30-minute Legal Consults with Legal Kitz per month</strong> (trusted legal support when you need it)",
        "<strong>10% discount on all Legal Kitz services</strong>",
        "<strong>100 GB data storage</strong>"
      ],
      "signOnFee": "+ Sign-on Fee"
    },
    "apa_discounted_essentials": {
      "name": "Essentials",
      "tagline": "The core solution every business needs to run effectively.",
      "price": "A$4",
      "priceAnnual": "A$703",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Choose Plan",
      "ctaSubtext": "12 month contract",
      "badge": "POPULAR",
      "features": [
        "100 eSignatures per month",
        "Tools to support Fair Work compliance",
        "Up to 15 Employee Profiles",
        "Up to 40 Supplier Profiles",
        "Up to 40 Customer Profiles",
        "Full access to the Australian Legal & Business Template Library, 115+ templates",
        "Unlimited Key Date extractions",
        "1 Legal Document Reviews per month",
        "2 x 30 Minutes Legal Consult per month",
        "10% discount for Legal Kitz services"
      ]
    },
    "free_essentials": {
      "name": "Essentials",
      "tagline": "The core solution every business needs to run effectively.",
      "price": "A$0",
      "priceAnnual": "A$703",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Choose Plan",
      "ctaSubtext": "12 month contract",
      "badge": "POPULAR",
      "features": [
        "100 eSignatures per month",
        "Tools to support Fair Work compliance",
        "Up to 15 Employee Profiles",
        "Up to 40 Supplier Profiles",
        "Up to 40 Customer Profiles",
        "Full access to the Australian Legal & Business Template Library, 115+ templates",
        "Unlimited Key Date extractions",
        "1 Legal Document Reviews per month",
        "2 x 30 Minutes Legal Consult per month",
        "10% discount for Legal Kitz services"
      ]
    },
    "growth": {
      "name": "Growth",
      "tagline": "For established businesses managing larger teams and more relationships.",
      "price": "A$129",
      "priceAnnual": "A$1,315",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Choose Plan",
      "ctaSubtext": "12 month contract",
      "features": [
        "<strong>200 eSignatures per month</strong>",
        "<strong>Audit trail for every document</strong> (a secure record of who signed and when)",
        "<strong>Secure document storage</strong>",
        "<strong>SmartVault</strong> (intelligent storage coming soon)",
        "<strong>Every Fair Work compliant employment template you need</strong> (hire and manage staff with confidence)",
        "<strong>Full access to the Document Library</strong> (115+ contracts, policies and agreements by trusted Australian lawyers)",
        "<strong>Up to 40 Employee Profiles with simple workflows</strong> (every employee record and contract, securely stored in one place)",
        "<strong>Up to 100 Supplier Profiles with simple workflows</strong> (every supplier and contractor agreement and renewal date, securely stored in one place)",
        "<strong>Up to 100 Customer Profiles with simple workflows</strong> (every customer record and contract, securely stored in one place)",
        "<strong>Unlimited Key Date extractions</strong> (renewals, expiries and annual deadlines such as insurance and licences, tracked in your Key Dates Dashboard)",
        "<strong>2 Legal Document Review by Legal Kitz per month</strong> (a lawyer checks your contract before you sign)",
        "<strong>3 x 30-minute Legal Consults with Legal Kitz per month</strong> (trusted legal support when you need it)",
        "<strong>10% discount on all Legal Kitz services</strong>",
        "<strong>500 GB data storage</strong>"
      ],
      "signOnFee": "+ Sign-on Fee"
    },
    "free_growth": {
      "name": "Growth",
      "tagline": "Maximise efficiency with advanced automation.",
      "price": "A$0",
      "priceAnnual": "A$1315",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Choose Plan",
      "ctaSubtext": "12 month contract",
      "features": [
        "200 eSignatures per month",
        "Tools to support Fair Work compliance",
        "Up to 40 Employee Profiles, for end to end Fair Work compliance",
        "Up to 100 Supplier Profiles",
        "Up to 100 Customer Profiles",
        "3 Legal Document Reviews per month",
        "4 x 30 minutes Legal consults per month",
        "15% member discount on all Legal Kitz services",
        "500 GB data storage"
      ]
    },
    "esign_only": {
      "name": "eSign & Storage",
      "tagline": "The best subscription to start eSigning and storing your documents.",
      "badge": "Best value for signing and storing",
      "price": "A$29",
      "priceAnnual": "A$295",
      "period": "/ Month",
      "periodAnnual": "/ Year",
      "cta": "Start eSigning",
      "ctaSubtext": "Cancel anytime.",
      "standaloneNote": "Standalone product",
      "standaloneNoteDetail": "This plan includes eSigning only. No access to full platform features.",
      "featuresHeader": "Key Features",
      "features": [
        "<strong>50 eSignatures per month</strong>",
        "<strong>Audit trail for every document</strong> (a secure record of who signed and when)",
        "<strong>Secure document storage</strong>",
        "<strong>SmartVault</strong> (intelligent storage coming soon)",
        "<strong>10 free high-quality Australian business templates</strong>",
        "<strong>Up to 5 Employee Profiles with simple workflows</strong>  (every employee record and contract, securely stored in one place)",
        "<strong>Up to 7 Supplier Profiles with simple workflows</strong>  (every supplier and contractor agreement and renewal date, securely stored in one place)",
        "<strong>Up to 7 Customer Profiles with simple workflows</strong> (every customer record and contract, securely stored in one place)",
        "<strong>10 GB data storage</strong>"
      ]
    }
  },
  "enterprise": {
    "header": "Enterprise & Custom Solutions",
    "description": "Talk to our specialists about advanced security, SLAs, custom integrations (SSO/ERP), and dedicated account management.",
    "cta": "Contact Sales"
  },
  "faq": {
    "header": "FAQs",
    "description": "Everything you need to know about your Business Kitz subscription.",
    "items": [
      {
        "question": "When was Business Kitz started, and by who?",
        "answer": "Business Kitz was founded in 2016 by a group of lawyers, accountants, and HR professionals who had worked with some of Australia's largest ASX-listed companies. Their mission was to provide small to medium businesses with affordable access to the legal, compliance, and HR tools usually reserved for big corporations."
      },
      {
        "question": "Does Business Kitz replace the need for a lawyer or HR consultant?",
        "answer": "For many small to medium businesses, Business Kitz replaces nearly the entire compliance function of a traditional HR manager. Our platform provides lawyer-drafted templates, policies, guides, and tools that cover the vast majority of day-to-day legal and HR needs.This allows your managers to focus on what really matters: engagement, culture, and growth while we handle the complex compliance work, including Fair Work obligations and legal updates. For high-risk or highly specific legal matters, we still recommend tailored advice via Legal Kitz, but for most businesses, Business Kitz is the complete compliance solution they need."
      },
      {
        "question": "How much does Business Kitz help me save?",
        "answer": "Business Kitz gives you access to over $125,000 worth of professionally drafted legal and HR templates, plus tools like e-signatures, task management, and compliance tracking, all for a flat, affordable subscription. Most businesses save thousands of dollars each year on legal and HR costs alone."
      },
      {
        "question": "How does Business Kitz compare to hiring a lawyer or HR consultant?",
        "answer": "Hiring a lawyer or HR consultant can cost between $300–$500 per hour. Even a single contract or compliance review can cost thousands. With Business Kitz, you get unlimited access to legal-grade documents and tools, without the hourly rate."
      },
      {
        "question": "Can Business Kitz help me avoid Fair Work fines?",
        "answer": "Yes. Under the Fair Work Act, penalties can reach $19,800 per breach for individuals and $99,000 per breach for companies, with significantly higher penalties for serious contraventions. Business Kitz helps protect you from these risks with up-to-date templates, automated legal updates and a full library of Fair Work–aligned resources."
      },
      {
        "question": "Can I try Business Kitz before committing long-term?",
        "answer": "Yes, you can set up a free account with limited access that showcases how the platform works. This allows you to explore features and see how Business Kitz can support your business before choosing a paid plan."
      },
      {
        "question": "What's included in the Business Kitz document library?",
        "answer": "The Business Kitz document library includes over 115 professionally drafted templates, created by top-tier Australian lawyers. These cover employment contracts, HR policies, legal compliance, contractor agreements, customer onboarding, and operations. Documents are fully editable in the platform, can be downloaded as Word files, and sent for eSigning in just a few clicks. This makes it easy to implement legally sound processes across your business without costly legal fees."
      },
      {
        "question": "What is the value of the legal and business documents included?",
        "answer": "The templates and tools within Business Kitz are valued at over AUD $125,000 if sourced individually from law firms. With your subscription, you gain unlimited access to this legal-grade content at a fraction of the price, empowering your business with the tools you need to operate professionally and compliantly."
      },
      {
        "question": "Are the legal documents kept up to date?",
        "answer": "Yes. Our legal team monitors all changes to Fair Work and other key legislation and updates our documents accordingly. Many traditional law firms and services do not offer ongoing updates, but with Business Kitz, you'll never miss an important legal change, we do the work for you."
      },
      {
        "question": "Does Business Kitz track key dates and reminders for me?",
        "answer": "Yes, our platform features an AI-powered Key Date Manager that automatically extracts important deadlines, such as contract renewals, probation reviews, and compliance tasks, from your documents. These key dates appear directly on your dashboard, helping you stay compliant and organised without lifting a finger."
      },
      {
        "question": "Can I e-sign documents on the platform?",
        "answer": "Yes! Business Kitz includes a powerful built-in e-signature tool that allows you to send any document, ours or your own, for legally binding eSigning in just a few clicks. There's no need for third-party apps, printing, or scanning: simply upload, customise, and send. Every document can also be intelligently tagged to its respective Business, Employee, Supplier, or Customer profile, automatically creating a secure and searchable audit trail. This is a standout feature of Business Kitz compared to other eSigning tools, giving you unmatched organisation, compliance, and visibility across your business."
      },
      {
        "question": "Can I upload and sign my own documents on the platform?",
        "answer": "Yes, you can upload your own Word or PDF files and use the Business Kitz platform to send them for secure, legally binding e-signatures. It's quick, compliant, and seamlessly integrated into your workflow."
      },
      {
        "question": "Can I manage tasks within the platform?",
        "answer": "Yes, Business Kitz includes a task management function right on your dashboard. You can create, assign, and track tasks across your team, making it easy to stay on top of key actions and keep your business running smoothly."
      },
      {
        "question": "What is Legal Kitz and how does it work?",
        "answer": "Legal Kitz is an Australian registered law firm and our trusted legal partner. If you ever have concerns about the validity of a document or face a legal issue, Legal Kitz is available to provide reliable, fast, and secure legal support. You can book consultations directly through the Business Kitz platform, giving you access to qualified Australian lawyers who can assist with document reviews, compliance concerns, or general legal advice, giving you peace of mind, whenever you need it."
      },
      {
        "question": "Are your legal documents up to date with Australian laws?",
        "answer": "Yes, all legal templates are drafted and regularly reviewed by qualified Australian lawyers to ensure compliance with current laws."
      },
      {
        "question": "What payment methods are accepted?",
        "answer": "We accept major credit cards and debit cards through our secure Stripe payment system."
      },
      {
        "question": "Can I switch between monthly and annual billing?",
        "answer": "Yes, absolutely. You can upgrade to annual billing at any time within your dashboard to take advantage of the 15% discount."
      },
      {
        "question": "What happens when I exceed my employee capacity?",
        "answer": "If your business grows and exceeds the employee limit of your plan, you'll be prompted to upgrade to a plan that fits your new size, ensuring continued compliance and full access."
      },
      {
        "question": "Is support included in all plans?",
        "answer": "Yes. All plans include support. The Free plan offers basic assistance, and all paid plans come with priority support and faster response times for a more personalised experience."
      },
      {
        "question": "Is Business Kitz secure?",
        "answer": "Absolutely. Business Kitz uses secure cloud infrastructure, SSL/TLS encryption, and regular system audits to keep your data and documents safe, private, and compliant with Australian standards."
      },
      {
        "question": "Can I extract my uploaded documents and data from the platform?",
        "answer": "Yes, this is possible. If you need to download or extract your uploaded documents or account data, simply contact our support team at support@businesskitz.com.au and they'll assist you promptly."
      },
      {
        "question": "Need help or support?",
        "answer": "If you need assistance, simply reach out to our support team at support@businesskitz.com.au. We're here to help you get the most out of your platform experience."
      },
      {
        "question": "Can I cancel or change my plan at any time?",
        "answer": "Yes, you can request to cancel or change your plan at any time. The eSign & Storage plan can be cancelled at any time. Essentials and Growth are 12-month plans: if you cancel, your plan remains active until the end of the 12-month contract period, so there is no sudden loss of access. Email <a href=\"mailto:support@businesskitz.com.au\">support@businesskitz.com.au</a> for assistance."
      }
    ]
  },
  "contractPeriod": "12 month contract.",
  "moreInfoLink": "More info",
  "subscriptionAgreementTextPartOne": "I agree to the ",
  "subscriptionAgreementTextPartTwo": " and acknowledge the 12-month Initial Term and automatic renewal for a further 12-month term unless I cancel at least 30 days before renewal.",
  "subscriptionAgreementTextPartTwoEsignOnly": " and acknowledge that this subscription is billed monthly and renews automatically each month unless cancelled. You may cancel at any time.",
  "businessKitzTermsAndConditions": "Business Kitz terms and conditions",
  "subscriptionAgreementTitle": "Platform terms and conditions",
  "inviteEmployee": "Invite employee",
  "employmentTemplatesInfo": {
    "employmentDocumentGuidance": "Employment Document Guidance",
    "employeeOnboarding": "Employee Onboarding - Documents Commonly Provided",
    "subcontractorEngagement": "Subcontractor Engagement - Documents Commonly Collected or Agreed",
    "supportCompliance": "To support compliance with the Fair Work Act and tax/super obligations, the following are typically provided to new employees at the time of engagement:",
    "fairWork": "Fair Work Information Statement (FWIS)",
    "casualEmployment": "Casual Employment Information Statement (CEIS) (for casual employees)",
    "taxFile": "Tax File Number (TFN) Declaration",
    "superannuationStandardChoiceForm": "Superannuation Standard Choice Form",
    "writtenEmploymentContract": "Written employment contract or letter of offer",
    "positionDescription": "Position description and/or policies",
    "safetyInduction": "Safety induction materials (as relevant)",
    "ensureClarity": "To ensure clarity and manage risk when engaging subcontractors, businesses typically:",
    "provideA": "Provide a",
    "contractorAgreement": "contractor agreement",
    "outliningScope": "outlining scope and payment",
    "collect": "Collect",
    "abnDetails": "ABN details",
    "request": "Request",
    "insuranceCertificates": "insurance certificates",
    "publicLiability": "(e.g. public liability, workers compensation)",
    "confirm": "Confirm",
    "invoicing": "invoicing and payment terms",
    "provideAny": "Provide any",
    "siteSafety": "site safety information or WHS induction",
    "confirmExpectations": "Confirm expectations regarding",
    "confidentially": "confidentiality and IP",
    "generalInNature": "This information is general in nature and not",
    "legalAdvice": "legal advice",
    "ensureCompliance": "Businesses should obtain professional advice to ensure compliance with applicable employment and workplace legislation."
  }
}
